import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/share')({
  component: () => (
    <Navigate
      from="/workspaces/$workspaceId/bots/$botId/webchat/v2/share"
      to="/workspaces/$workspaceId/bots/$botId/webchat/v2/identity"
    />
  ),
})
